<template>
    <div class="about-initiative-form1">
        <slot name="how-register-modal"></slot>

        <div class="edit-info" v-if="getEditionMode">
            <b-button
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                size="sm"
                @click="changeStatusDisabled(false)"
            >
                Editar informações
            </b-button>
        </div>

        <h6 style="margin-bottom: 24px;">
            Links das mídias sociais
        </h6>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <!-- <div class="lock-msg-top" v-if="showLock">
                <div class="msg">
                    {{
                        `Caso queira que suas informações ${
                            form.statusLock ? 'não sejam' : 'sejam'
                        } públicas, clique no botão abaixo.`
                    }}
                </div>

                <LockPP
                    :statusLock="Number(form.statusLock)"
                    :lockMsg="'Privado'"
                    :unlockMsg="'Público'"
                    @click="form.statusLock = Number(!form.statusLock)"
                />
            </div> -->

            <b-form-group label="Website" label-for="website">
                <b-form-input
                    id="website"
                    name="website"
                    v-model="form.website"
                    type="text"
                    placeholder="Digite aqui"
                    :disabled="getIsDisabled"
                ></b-form-input>
            </b-form-group>

            <b-form-group label="Blog" label-for="blog">
                <b-form-input
                    id="blog"
                    name="blog"
                    v-model="form.blog"
                    type="text"
                    placeholder="Digite aqui"
                    :disabled="getIsDisabled"
                ></b-form-input>
            </b-form-group>

            <b-form-group label="Facebook" label-for="facebook">
                <b-form-input
                    id="facebook"
                    name="facebook"
                    v-model="form.facebook"
                    type="text"
                    placeholder="Digite aqui"
                    :disabled="getIsDisabled"
                ></b-form-input>
            </b-form-group>

            <b-form-group label="Instagram" label-for="instagram">
                <b-form-input
                    id="instagram"
                    name="instagram"
                    v-model="form.instagram"
                    type="text"
                    placeholder="Digite aqui"
                    :disabled="getIsDisabled"
                ></b-form-input>
            </b-form-group>

            <b-form-group label="YouTube" label-for="youtube">
                <b-form-input
                    id="youtube"
                    name="youtube"
                    v-model="form.youtube"
                    type="text"
                    placeholder="Digite aqui"
                    :disabled="getIsDisabled"
                ></b-form-input>
            </b-form-group>

            <b-form-group label="Tik Tok" label-for="tiktok">
                <b-form-input
                    id="tiktok"
                    name="tiktok"
                    v-model="form.tiktok"
                    type="text"
                    placeholder="Digite aqui"
                    :disabled="getIsDisabled"
                ></b-form-input>
            </b-form-group>

            <b-form-group label="Twitter" label-for="twitter">
                <b-form-input
                    id="twitter"
                    name="twitter"
                    v-model="form.twitter"
                    type="text"
                    placeholder="Digite aqui"
                    :disabled="getIsDisabled"
                ></b-form-input>
            </b-form-group>

            <b-form-group label="LinkedIn" label-for="linkedin">
                <b-form-input
                    id="linkedin"
                    name="linkedin"
                    v-model="form.linkedin"
                    type="text"
                    placeholder="Digite aqui"
                    :disabled="getIsDisabled"
                ></b-form-input>
            </b-form-group>

            <b-form-group label="Outro e-mail" label-for="emailOther">
                <b-form-input
                    id="emailOther"
                    name="emailOther"
                    v-model="$v.form.emailOther.$model"
                    type="text"
                    placeholder="Digite aqui"
                    :state="validateState('emailOther')"
                    :disabled="getIsDisabled"
                ></b-form-input>

                <b-form-invalid-feedback :state="validateState('emailOther')">
                    <div v-if="!$v.form.emailOther.email">Escreva um e-mail válido</div>
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Outros (especifique)" label-for="others">
                <b-form-input
                    id="others"
                    name="others"
                    v-model="form.others"
                    type="text"
                    placeholder="Digite aqui"
                    :disabled="getIsDisabled"
                ></b-form-input>
            </b-form-group>

            <hr class="line" />

            <div class="footer-buttons">
                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="$router.push({ name: 'FirstInformationForm2' })"
                    v-if="!showFooterButtons"
                    >Voltar</b-button
                >

                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!showFooterButtons"
                    >Próximo</b-button
                >

                <div class="display-initial" v-if="showFooterButtons">
                    <b-button :variant="'secondary'" @click="changeRegisterForm('FirstInformationForm2')"
                        >Voltar</b-button
                    >

                    <b-button :variant="'primary'" @click="changeRegisterForm('AboutInitiativeForm2')">
                        Próximo
                    </b-button>
                </div>

                <b-button
                    variant="success"
                    @click=";(isUpdate = true), onSubmit()"
                    v-if="getEditionMode && !getIsDisabled"
                >
                    Salvar
                </b-button>
            </div>
        </b-form>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import LockPP from '@/ui/lock-pp/LockPP'
import { email } from 'vuelidate/lib/validators'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import { AboutInitiativeApi } from '../../api/about-initiative'
import { AuthorizationApi } from '../../api/admin/authorization-api'

const authorizationApi = new AuthorizationApi()
const aboutInitiativeApi = new AboutInitiativeApi()

export default {
    components: { LockPP, DangerModalPP },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        receiveData: {
            default: null
        },
        showFooterButtons: {
            type: Boolean,
            default: false
        },
        userIdLogged: {
            default: null
        },
        allowAuthorization: {
            type: Boolean,
            default: false
        },
        showLock: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            progress: 19.39,
            message: null,
            initiative: null,
            isUpdate: false,
            isDisabled: null,
            authorizationData: null,
            form: {
                statusLock: 1,
                website: null,
                blog: null,
                facebook: null,
                instagram: null,
                youtube: null,
                tiktok: null,
                twitter: null,
                linkedin: null,
                emailOther: null,
                others: null
            }
        }
    },
    validations: {
        form: {
            emailOther: { email }
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform', 'setProgress']),
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        fetchRead() {
            const data = this.receiveData
            this.initiative = data

            this.form.blog = data.blog
            this.form.website = data.web_site
            this.form.facebook = data.facebook
            this.form.instagram = data.instagram
            this.form.youtube = data.youtube
            this.form.tiktok = data.tiktok
            this.form.twitter = data.twitter
            this.form.linkedin = data.linkedin
            this.form.emailOther = data.outro_email
            this.form.others = data.outro
            this.form.statusLock = data.view_social

            this.fetchAuthorization()
        },
        fetch() {
            this.usuario = JSON.parse(localStorage.getItem('usuario'))
            this.setIsLoading(true)

            aboutInitiativeApi
                .getAboutInitiative()
                .then(response => {
                    const data = response.data.data
                    if (data !== null) {
                        this.initiative = data
                        this.form.blog = data.blog
                        this.form.website = data.web_site
                        this.form.facebook = data.facebook
                        this.form.instagram = data.instagram
                        this.form.youtube = data.youtube
                        this.form.tiktok = data.tiktok
                        this.form.twitter = data.twitter
                        this.form.linkedin = data.linkedin
                        this.form.others = data.outro
                        this.form.emailOther = data.outro_email
                        this.form.statusLock = data.view_social
                    }
                })
                .finally(() => this.setIsLoading(false))
        },
        onSubmit() {
            const currentProgress = this.getProgress < this.progress ? this.progress : this.getProgress

            const defaultData = {
                blog: this.form.blog,
                web_site: this.form.website,
                facebook: this.form.facebook,
                instagram: this.form.instagram,
                youtube: this.form.youtube,
                tiktok: this.form.tiktok,
                twitter: this.form.twitter,
                linkedin: this.form.linkedin,
                outro_email: this.form.emailOther,
                outro: this.form.others,
                view_social: this.form.statusLock,
                percentual: currentProgress
            }

            const data = this.isUpdate
                ? {
                      ...this.initiative,
                      ...defaultData
                  }
                : defaultData

            this.setIsLoading(true)
            const request = this.isUpdate
                ? aboutInitiativeApi.updateAboutInitiative(data)
                : aboutInitiativeApi.createAboutInitiative(data)

            request
                .then(response => {
                    this.setProgress(data.percentual)
                    this.isUpdate
                        ? this.changeStatusDisabled(true)
                        : this.$router.push({ name: 'AboutInitiativeForm2' })
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-register-painel')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        fetchAuthorization() {
            if (this.allowAuthorization) {
                this.setIsLoading(true)

                authorizationApi
                    .getAboutInitiative(this.userIdLogged)
                    .then(response => {
                        if (response.data.data === null || response.data.data.length === 0) {
                            this.authorizationData = null
                        } else {
                            this.authorizationData = response.data.data
                        }
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        }
    },
    computed: {
        getEditionMode() {
            return this.editionMode
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getProgress() {
            return this.$store.state.progress
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getProfileId() {
            return this.$store.state.profileId
        },
        getAuthorizationData() {
            return this.authorizationData
        }
    },
    created() {
        this.isDisabled = this.disabled
        this.receiveData === null ? this.fetch() : this.fetchRead()
    }
}
</script>

<style scope src="./AboutInitiativeForm1-light-theme.css"></style>



// WEBPACK FOOTER //
// src/components/register-about-initiative-forms/AboutInitiativeForm1.vue